import React from 'react';
import { Button, Dropdown, Tooltip } from 'antd';
import type { MenuProps } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { downloadMassiveLabels } from 'services/MassiveService';
import { downloadOrNotify } from './download';

interface Props {
  massiveId: string;
  disabled?: boolean;
  createdCount: number;
}

const MassiveLabelsButton = ({ massiveId, disabled, createdCount }: Props) => {
  const download = (format: 'pdf' | 'zpl') =>
    downloadOrNotify(
      () => downloadMassiveLabels(massiveId, format),
      `${massiveId}-etiquetas.${format}`,
    );

  const items: MenuProps['items'] = [
    {
      key: 'pdf',
      label: 'Etiquetas en PDF',
      onClick: () => download('pdf'),
    },
    {
      key: 'zpl',
      label: 'Etiquetas en ZPL',
      onClick: () => download('zpl'),
    },
  ];

  if (disabled || createdCount === 0) {
    return (
      <Tooltip title="Todavía no hay etiquetas para descargar">
        <Button icon={<DownloadOutlined />} disabled />
      </Tooltip>
    );
  }

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button type="primary" icon={<DownloadOutlined />} />
    </Dropdown>
  );
};

export default MassiveLabelsButton;
